<template>
  <span
    class="request-password-reset-btn"
  >
    <button
      type="button"
      class="btn btn-danger btn-sm"
      v-on:click="requestPasswordResetConfirm"
    >
      {{ buttonStr }}

      <spinner
        size="small"
        v-if="loaders.sendingPasswordResetEmail"
      />
    </button>
  </span>
</template>
<script>
import Spinner from 'vue-simple-spinner'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  props: {
    email: {
      type: String,
      default: undefined,
      required: true
    },

    buttonStr: {
      type: String,
      default: 'Send Password Reset Email'
    }
  },

  computed: mapState({
    loaders: state => state.LoaderModule.loaders
  }),

  components: {
    'spinner': Spinner
  },

  methods: {
    requestPasswordResetConfirm () {
      if (
        confirm('Are you sure you want to send this user a password reset email?')
      ) {
        this.$store.dispatch(
          `UserModule/requestPasswordReset`, this.email
        ).then(() => {
          FlashStore.result('Password reset email sent!')
          this.$emit('onPasswordResetSuccess')
        }).catch(this.$root.processErrors)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestPasswordResetButton.vue